import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Redes from "./pages/Redes";
import { Toaster } from "sonner";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/redes" element={<Redes />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      <Analytics />
    </div>
  );
}

export default App;
